import axiosInstance from './axiosInstance';
import { PAGINATION } from '../constants';

const multipartConfig = { headers: { 'Content-Type': 'multipart/form-data' } };

const api = {
  login: (username, password, platform = 'WEB') =>
    axiosInstance.post('/v1/user/login', { username, password, platform }),

  getMyAziende: () => axiosInstance.get('/v1/user/aziende'),
  getAzienda: () => axiosInstance.get('/azienda'),
  getAziendaByUser: (userId) => axiosInstance.get(`/azienda/user/${userId}`),
  updateAzienda: (data) => axiosInstance.put('/azienda', data),
  updateAziendaByUser: (userId, data) =>
    axiosInstance.put(`/azienda/user/${userId}`, data),

  listUsers: (page, size = PAGINATION.PAGE_SIZE) =>
    axiosInstance.get('/v1/user/list', { params: { page, size } }),
  toggleUserStatus: (userId, active) =>
    axiosInstance.put(`/v1/user/${userId}/status`, { active }),
  deleteUser: (userId) => axiosInstance.delete(`/v1/user/${userId}`),

  listEventi: (aziendaId, page, size = PAGINATION.PAGE_SIZE, sort = PAGINATION.DEFAULT_SORT, signal) =>
    axiosInstance.get(`/azienda/eventi/${aziendaId}`, {
      params: { page, size, sort },
      signal,
    }),
  toggleEventoStatus: (eventoId) =>
    axiosInstance.put(`/azienda/eventi/${eventoId}/stato`, {}),
  deleteEvento: (eventoId) =>
    axiosInstance.delete(`/azienda/eventi/${eventoId}`),

  getCategorie: () => axiosInstance.get('/eventi/tipologie'),
  getAziendaCategorie: () => axiosInstance.get('/util/aziende/category'),

  uploadProfileImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/azienda/uploadProfileImage', formData, multipartConfig);
  },
  uploadProfileImageByUser: (userId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post(`/azienda/uploadProfileImage/${userId}`, formData, multipartConfig);
  },
  uploadGallery: (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return axiosInstance.post('/azienda/uploadGallery', formData, multipartConfig);
  },
  /* ATTENZIONE: il backend non e' uniforme, e i nomi dei @PathVariable
   * ingannano. Semantica reale, letta dai service:
   *   uploadProfileImage/{x} -> ID UTENTE   (utentiRepository.findById)
   *   immagini/profile/{x}   -> ID UTENTE   (utentiRepository.findById)
   *   uploadGallery/{x}      -> ID AZIENDA  (aziendaRepository.findById)
   *   immagini/azienda/{x}   -> ID AZIENDA  (aziendaRepository.findById)
   * Prima si passava ovunque l'id utente: per le due della galleria e'
   * sbagliato, ma l'errore restava invisibile perche' per gli utenti storici
   * id_utente e id_azienda coincidono (utente 6 / azienda 6). Per l'utente 39,
   * la cui azienda e' la 33, la galleria veniva cercata sull'azienda 39. */
  uploadGalleryByAzienda: (idAzienda, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return axiosInstance.post(`/azienda/uploadGallery/${idAzienda}`, formData, multipartConfig);
  },
  getGalleria: () => axiosInstance.get('/azienda/immagini'),
  getGalleriaByAzienda: (idAzienda) =>
    axiosInstance.get(`/azienda/immagini/azienda/${idAzienda}`),
  getProfileImageByUser: (userId) =>
    axiosInstance.get(`/azienda/immagini/profile/${userId}`),
  // --- Storico prenotazioni (admin e azienda stessa) ---
  storicoPrenotazioni: (idAzienda, pagina = 0, dimensione = 20) =>
    axiosInstance.get(`/prenotazioni/azienda/${idAzienda}`, {
      params: { pagina, dimensione },
    }),

  // --- Categorie su due livelli (solo admin) ---
  alberoTipologie: () => axiosInstance.get('/tipologie'),
  tuttiTipiEvento: () => axiosInstance.get('/tipologie/evento'),
  creaCategoria: (dati) => axiosInstance.post('/tipologie/categoria', dati),
  aggiornaCategoria: (id, dati) => axiosInstance.put(`/tipologie/categoria/${id}`, dati),
  eliminaCategoria: (id) => axiosInstance.delete(`/tipologie/categoria/${id}`),
  creaTipoEvento: (dati) => axiosInstance.post('/tipologie/evento', dati),
  aggiornaTipoEvento: (id, dati) => axiosInstance.put(`/tipologie/evento/${id}`, dati),
  eliminaTipoEvento: (id) => axiosInstance.delete(`/tipologie/evento/${id}`),
  associaTipoEvento: (idCategoria, idTipoEvento, ordine) =>
    axiosInstance.put(`/tipologie/categoria/${idCategoria}/evento/${idTipoEvento}`, { ordine }),
  dissociaTipoEvento: (idCategoria, idTipoEvento) =>
    axiosInstance.delete(`/tipologie/categoria/${idCategoria}/evento/${idTipoEvento}`),
  assegnaCategoriaAzienda: (idAzienda, code) =>
    axiosInstance.put(`/azienda/${idAzienda}/categoria`, { code }),

  // --- Strumenti admin sugli accessi ---
  inviaAccesso: (idUtente) => axiosInstance.post(`/v1/user/${idUtente}/invia-accesso`),
  inviaAccessoMassivo: (ruolo = 'ROLE_AZIENDA', simula = true) =>
    axiosInstance.post('/v1/user/invia-accesso-massivo', null, { params: { ruolo, simula } }),
  impostaPasswordDaAdmin: (idUtente, nuovaPassword) =>
    axiosInstance.put(`/v1/user/${idUtente}/password-admin`, { nuovaPassword }),

  // --- Stripe Connect ---
  statoStripe: (idAzienda) => axiosInstance.get(`/azienda/stripe/stato/${idAzienda}`),
  linkOnboardingStripe: (idAzienda) =>
    axiosInstance.post(`/azienda/stripe/link-onboarding/${idAzienda}`),

  deleteImmagine: (idImmagine) =>
    axiosInstance.delete(`/azienda/immagini/${idImmagine}`),
};

export default api;
